import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "items-center flex space-x-2" }
const _hoisted_2 = { class: "items-center flex space-x-2" }
const _hoisted_3 = { class: "items-center flex space-x-2" }

import { PropType } from 'vue';
import Dialog from '../ui/dialog/Dialog.vue';
import DialogContent from '../ui/dialog/DialogContent.vue';
import DialogHeader from '../ui/dialog/DialogHeader.vue';
import DialogTitle from '../ui/dialog/DialogTitle.vue';
import DialogTrigger from '../ui/dialog/DialogTrigger.vue';
import { WorkflowTask } from '@/http/workflowTask';
import Input from '../ui/input/Input.vue';
import Label from '../ui/label/Label.vue';
import Checkbox from '../ui/checkbox/Checkbox.vue';
import Separator from '../ui/separator/Separator.vue';
import Textarea from '../ui/textarea/Textarea.vue';
import DialogFooter from '../ui/dialog/DialogFooter.vue';
import Button from '../ui/button/Button.vue';
import DialogClose from '../ui/dialog/DialogClose.vue';
import { CircleX } from 'lucide-vue-next';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkflowTaskSettings',
  props: {
    "workflowTask": {
  type: Object as PropType<WorkflowTask>,
  required: true,
},
    "workflowTaskModifiers": {},
    "modelValue": {
  required: false,
  default: false
},
    "modelModifiers": {},
  },
  emits: ["update:workflowTask", "update:modelValue"],
  setup(__props) {

const workflowTask = _useModel(__props, 'workflowTask');

const open = _useModel(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dialog, {
    open: open.value,
    "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((open).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(DialogTrigger, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createVNode(DialogContent, null, {
        default: _withCtx(() => [
          _createVNode(DialogHeader, { class: "flex flex-row justify-between items-center" }, {
            default: _withCtx(() => [
              _createVNode(DialogTitle, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Configurações da Tarefa ")
                ]),
                _: 1
              }),
              _createVNode(DialogClose, null, {
                default: _withCtx(() => [
                  _createVNode(Button, {
                    variant: "ghost",
                    class: "px-1.5",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleX), { class: "text-gray-600" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(Separator, {
            class: "bg-gray-200",
            orientation: "horizontal"
          }),
          _createVNode(Label, {
            class: "font-semibold",
            for: "content"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Conteúdo:")
            ]),
            _: 1
          }),
          _createVNode(Textarea, {
            id: "content",
            class: "resize-none bg-white",
            modelValue: workflowTask.value.content,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workflowTask.value.content) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Label, {
              for: "footer",
              class: "font-semibold"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Rodapé:")
              ]),
              _: 1
            }),
            _createVNode(Input, {
              id: "footer",
              modelValue: workflowTask.value.footer,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((workflowTask.value.footer) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Label, {
              for: "buttonText",
              class: "font-semibold w-36"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Texto do botão:")
              ]),
              _: 1
            }),
            _createVNode(Input, {
              id: "buttonText",
              modelValue: workflowTask.value.buttonText,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((workflowTask.value.buttonText) = $event)),
              maxlength: "20"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(Separator, {
            class: "bg-gray-200",
            orientation: "horizontal"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Checkbox, {
              id: "shouldWaitReply",
              checked: workflowTask.value.shouldWaitReply,
              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((workflowTask.value.shouldWaitReply) = $event))
            }, null, 8, ["checked"]),
            _createVNode(Label, {
              for: "shouldWaitReply",
              class: "font-semibold"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Salvar Resposta")
              ]),
              _: 1
            }),
            _createVNode(Separator, {
              class: "bg-gray-200",
              orientation: "vertical"
            }),
            _createVNode(Label, {
              for: "userAttribute",
              class: _normalizeClass(["w-32 font-semibold", {
            'text-muted': !workflowTask.value.shouldWaitReply
          }])
            }, {
              default: _withCtx(() => [
                _createTextVNode("Salvar em:")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(Input, {
              id: "userAttribute",
              modelValue: workflowTask.value.userAttribute,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((workflowTask.value.userAttribute) = $event)),
              disabled: !workflowTask.value.shouldWaitReply
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createVNode(DialogFooter, null, {
            default: _withCtx(() => [
              _createVNode(Button, {
                type: "button",
                onClick: _cache[6] || (_cache[6] = () => open.value = false),
                variant: "ghost",
                class: "py-0.5"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(Button, {
                variant: "default",
                onClick: _cache[7] || (_cache[7] = () => open.value = false),
                class: "px-4",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Salvar")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})